import { useLocation } from "react-router";

export function useSetQuery(): [URLSearchParams, Function] {
  const url = useLocation().search;
  let queries = new URLSearchParams(url);
  let reencode = false;

  try {
    const decodedQueries = decodeURIComponent(url);
    queries = new URLSearchParams(decodedQueries);
    reencode = true;
  } catch (error) {
    console.warn(error);
  }

  const setQuery = (urlObject: object): URLSearchParams | string => {
    for (const [key, value] of Object.entries(urlObject)) {
      queries.set(key, value);
    }
    if (reencode) {
      return encodeURIComponent(queries.toString());
    }
    return queries;
  };
  return [queries, setQuery]; // probably only needs to return setQuery.
}
